import React, { useState, useEffect } from "react"
import Loading from "../../components/Loading"
import TakenExamDetailModal from './TakenExamDetailModal'


import Dropdown from './../../images/icons/drop-down.png'

import { apiCall, validateToken, detectExamStatus } from './../../../Helper'
import { navigate } from "gatsby"

const htmlToText = require('html-to-text')

export default ({ id }) => {
  if (!id) navigate('/exam/taken-exams')

  const [exam, setExam] = useState({})
  const [questions, setQuestions] = useState([])
  const [responses, setResponses] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [showDetailModal, setShowDetailModal] = useState(false)

  const [answerIndex, setAnswerIndex] = useState(false)

  function getExam() {
    setIsLoading(true)
    apiCall({
      url: '/newExams/takenExam',
      params: {
        taken_exam_id: id
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        if (res.data.code === 403) navigate('/exam/taken-exams')
        setExam(res.data)
        setQuestions(res.data.questions)
        setResponses(res.data.user_responses)
      } else navigate('/exam/taken-exams')
    }).catch(err => { navigate('/exam/taken-exams'); setIsLoading(false) })
  }

  useEffect(() => { validateToken(); getExam() }, [])

  return (
    <div>
      <h3 className="m-0 text-shadow font-16 px-16">کارنامه</h3>
      <hr className="mb-0" />

      <div className="mt-16 px-32">
        <h4 className="font-14 text-shadow">{exam.exam?.group ? (exam.exam?.group?.title + ' - ') : ''}{exam.exam?.title}</h4>
        <div className="px-8 flexed align-c">
          <div className="flex-1">
            <span className="">حد نصاب: </span>
            <span className="bold px-6 font-13">{`${exam.exam?.pass_percent}`} درصد</span>
          </div>
          <div className="flex-1">
            <span className="">امتیاز: </span>
            <span className="bold px-6 font-13">{`${exam.percent?.toString().slice(0, 5)}`} درصد</span>
          </div>
          <div className="flex-1">
            <span className="">وضعیت: </span>
            <span className={"bold px-6 font-13 " + (detectExamStatus(exam.percent, exam.exam?.pass_percent) ? "text-success" : "text-tomato")}>{detectExamStatus(exam.percent, exam.exam?.pass_percent) ? 'قبول' : 'مردود'}</span>
          </div>
          <div className="flex-3 ltr">
            <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav"
              onClick={() => setShowDetailModal(true)}
              style={{ color: 'var(--tomato)', padding: '5px 0', width: 100, border: '1px solid var(--tomato)' }}>جزئیات آزمون</button>
          </div>
        </div>

        <div>
          {
            questions?.map((question, index) => {
              let e = -1
              for (let i = 0; i < responses.length; i++) {
                if (responses[i].question_id === question.question_id)
                  e = responses[i].response
              }
              return (
                <div className="bg-top-nav mt-45 p-22" key={index}>
                  <h4 className="m-0 pr-16">سوال {index + 1}</h4>
                  <hr />
                  <p className="px-16 text-shadow mb-0" style={{ lineHeight: 2.3 }}>{htmlToText.fromString(question.text)}</p>
                  <br />
                  <div className="grid px-32" style={{ gap: 16 }}>
                    <div className={"iran-sans-light " + (question.answer !== 1 ? (e === 1 && 'text-tomato') : 'text-success')}>
                      <input readOnly type="checkbox" className={"ml-8 " + (question.answer !== 1 ? e === 1 && 'tomato' : 'success')}
                        checked={e === 1} />
                      الف) {question.ans_1}
                    </div>
                    <div className={"iran-sans-light " + (question.answer !== 2 ? (e === 2 && 'text-tomato') : 'text-success')}>
                      <input readOnly type="checkbox" className={"ml-8 " + (question.answer !== 2 ? e === 2 && 'tomato' : 'success')}
                        checked={e === 2} />
                      ب) {question.ans_2}
                    </div>
                    <div className={"iran-sans-light " + (question.answer !== 3 ? (e === 3 && 'text-tomato') : 'text-success')}>
                      <input readOnly type="checkbox" className={"ml-8 " + (question.answer !== 3 ? e === 3 && 'tomato' : 'success')}
                        checked={e === 3} />
                      ج) {question.ans_3}
                    </div>
                    <div className={"iran-sans-light " + (question.answer !== 4 ? (e === 4 && 'text-tomato') : 'text-success')}>
                      <input readOnly type="checkbox" className={"ml-8 " + (question.answer !== 4 ? e === 4 && 'tomato' : 'success')}
                        checked={e === 4} />
                      د) {question.ans_4}
                    </div>
                  </div>

                  {question.full_answer && <div className="grid pr-32 pl-8">
                    <div className="ltr">
                      <button className="bd-none bg-none iran-sans" onClick={() => setAnswerIndex(answerIndex !== index ? index : false)}>
                        <span className="bg-footer mr-12 icon-mask inline-blocked" style={{
                          WebkitMaskImage: `url(${Dropdown})`,
                          WebkitMaskSize: 'contain',
                          marginBottom: -5, width: 12, height: 12,
                          transform: answerIndex === index ? 'rotate(180deg)' : ''
                        }} />
                        پاسخ تشریحی
                      </button>
                    </div>
                    {answerIndex === index && <div className="mt-32 slideInBottom iran-sans-light font-11">{htmlToText.fromString(question.full_answer)}</div>}
                  </div>}
                </div>
              )
            })
          }
        </div>

      </div>

      <TakenExamDetailModal full show={showDetailModal} toggleShow={setShowDetailModal} exam={exam} noAction />
      <Loading full show={isLoading} />
    </div>
  )
}
